import { Copy, Plus, Search } from "lucide-react";
import { useState } from "react";

import { RadioPanels } from "~/components/shared/radio-panels";
import { Button } from "~/components/ui/button";

import type { ModalTypes } from "./types";

export const ModalTypeForm = ({
  onSubmit,
}: {
  onSubmit: (itemType: ModalTypes) => void;
}) => {
  const [itemType, setItemType] = useState<ModalTypes>("newItem");
  return (
    <form
      className="space-y-5"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(itemType);
      }}
    >
      <RadioPanels
        items={[
          {
            value: "newItem",
            label: "New Item",
            description: "Create a new item from scratch",
            icon: Plus,
          },
          {
            value: "duplicate",
            label: "Duplicate similar item",
            description: "Choose an existing item to use as a template",
            icon: Copy,
          },
          {
            value: "existingItem",
            label: "Add existing item",
            description: "Share and sync an item across multiple menus",
            icon: Search,
          },
        ]}
        onValueChange={setItemType}
        orientation="vertical"
        value={itemType}
      />
      <Button className="w-full" size="lg" type="submit">
        Next
      </Button>
    </form>
  );
};
